import moment from "moment";
import { getCoursePricingDetails } from "./service";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";

export const COURSE_END_DATE_BUFFER_ISSUANCE = 30;
export const checkCourseEndDatePassed = async (application, bufferDays) => {
  const { businessArea, courseId, term } = application || {};
  const res = await getCoursePricingDetails(courseId, businessArea, term);

  const buffer = bufferDays || COURSE_END_DATE_BUFFER_ISSUANCE;
  const today = moment().startOf("day");

  const startAllowed = moment(res.courseStartDate)
    .subtract(buffer.startDateBufferDay, "days")
    .startOf("day");

  const endAllowed = moment(res.courseEndDate)
    .add(buffer.endDateBufferDay, "days")
    .startOf("day");

  if (today.isBefore(startAllowed) || today.isAfter(endAllowed)) {
    failureToast(
      "Issuance against a course can be made only between course start date and end date",
    );

    return true;
  }
};

export const ERROR_MGS_WHILE_SAP_DOWN =
  "Please connect with productsupport@aesl.in or try again later.";
